import { useEffect, useCallback, useState } from 'react';

import { Trace } from '@utilities/logging';

/**
 * Get the values of the given properties from blueconic
 * @param properties An array with the unique IDs of the profile (BC) properties that must be loaded
 */
export const useBlueConicValues = (properties: string[]) => {
  const [values, setValues] = useState<{ [key: string]: string }>({});
  const loadAndGetValues = useCallback(() => {
    Trace('useBlueConicValues.loadAndGetValues');
    const profile = window.blueConicClient.profile.getProfile();

    profile.loadValues(properties, this, () => {
      Trace('useBlueConicValues.loadValues');

      const vals: { [key: string]: string } = {};
      // Values have been loaded, safe to get no
      properties.forEach((property) => {
        vals[property] = profile.getValue(property);
      });
      Trace('useBlueConicValues.loadValues', vals);
      setValues(vals);
    });
  }, [properties]);

  useEffect(() => {
    if (properties && properties.length > 0) {
      if (window?.blueConicClient) {
        // BlueConic is loaded, get the properties
        loadAndGetValues();
      } else {
        // Wait for BlueConic to load
        window.addEventListener('onBlueConicLoaded', loadAndGetValues, false);
      }

      return () => {
        window.removeEventListener('onBlueConicLoaded', loadAndGetValues);
      };
    }
  }, [loadAndGetValues, properties]);
  return { values };
};
